import React, { Component } from "react";
import ProductBase from './product-base.jsx';
import wishlist from '../../components/wishlist';
import toast from '../../components/toast';

class WishlistProduct extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false
        };

        this.handleDeleteClick = this.handleDeleteClick.bind(this);
    }

    handleDeleteClick(e) {
        this.setState({
            isLoading: true
        });

        wishlist.delete(this.props.skuNumber)
            .then(() => {
                this.props.onDelete();
                toast.success('Removed from your wish list');
            })
            .catch(error => {
                console.log(error);
                toast.error('There was an error trying to remove this product');
            })
            .finally(() => {
                this.setState({
                    isLoading: false
                });
            });
    }

    render() {
        const actions = <div class="full-card-actions">
            <button class="btn btn-outline-alt" type="button" onClick={this.handleDeleteClick} disabled={this.state.isLoading}>
                <span>Remove</span> 
                <svg className="icon icon-trash"><use xlinkHref="#icon-trash"></use></svg>
            </button>
        </div>;

        return (
            <ProductBase {...this.props} actions={actions} />
        );
    }
}

WishlistProduct.defaultProps = {
    onDelete: function () { }
};

export default WishlistProduct;